import getChainType from './getChainType'
import callPublicReportData from '../../liveReportHelpers/callPublicReportData'

/**
 * Question vs MSIEffect for a matrix field. Logged in, the hook reads
 * `Synchronisations` itself; in the public report view that read is refused,
 * so the server answers instead (functions/liveReports/resolveChainType.js,
 * parity-pinned against getChainType). Errors propagate — no silent fallback
 * to 'Question'.
 *
 * @param {object} args
 * @param {string} args.field - QuestionnaireFields `ID`
 * @param {object} args.db - Firestore client
 * @param {Map<string, string>} args.cache - Session cache for getChainType
 * @param {import('../../../StateManagment/PublicReportContext').PublicReport|null} args.publicReport - From PublicReportContext
 * @returns {Promise<'Question'|'MSIEffect'>}
 */
const resolveMatrixChainType = async ({ field, db, cache, publicReport }) => {
    if (!publicReport) return getChainType(field, db, cache)
    const { chainType } = await callPublicReportData({
        reportId: publicReport.reportId,
        code: publicReport.code,
        kind: 'chainType',
        id: field,
    })
    return chainType
}

export default resolveMatrixChainType
